export const COMPLETE_SIGN_UP_STEP = 'complete_signup_step'
export const COMPLETE_SIGN_UP_ADD_AGENCY_STEP = 'add-agency-step'

// Company size specified by user on the Add Agency step of the Complete Sign Up process.
// This value is used on the next step (Invite Teammates) to limit number of users that can be invited.
export const COMPLETE_SIGN_UP_USER_SPECIFIED_COMPANY_SIZE = 'user_specified_company_size'

// Indicates the state of the Documents Preview Panel used for previewing Invoices and Payouts
export const INVOICE_DOCUMENT_PREVIEW_VISIBLE = 'invoice_document_preview_visible'
